/* Book product page (sections/book.liquid): the page's pure rules, no DOM. Used by assets/book-pdp.js; tested by
 * _review/test-book-pdp.js (node). The title split, the display title, the colophon heading and the size line are
 * rendered server-side by the section; the functions here are the same rules, kept in step with the Liquid so the
 * tests document them. The cover placement, the pixel measure and the tier prices run in the browser.
 * Prices are cents. Boxes are fractions of the image (x of its width, y of its height). */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.BookPdpModel = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // The book's own title, split for display: at the first ":"; else after the first "!"; else after
  // "Good. Better. Best."; else no subtitle. sep is what joins the two parts back into the full title (the h1 carries
  // it visually hidden).
  var GBB = 'Good. Better. Best.';
  function splitTitle(title) {
    var t = String(title || '').trim(), i;
    if ((i = t.indexOf(':')) !== -1) return { main: t.slice(0, i).trim(), sub: t.slice(i + 1).trim(), sep: ': ' };
    if ((i = t.indexOf('!')) !== -1) return { main: t.slice(0, i + 1).trim(), sub: t.slice(i + 1).trim(), sep: ' ' };
    if ((i = t.indexOf(GBB)) !== -1) return { main: t.slice(0, i + GBB.length).trim(), sub: t.slice(i + GBB.length).trim(), sep: ' ' };
    return { main: t, sub: '', sep: '' };
  }

  // A main title set in capitals (as on the cover) shows in title case: each word capitalised, the rest lower case,
  // so "CHOMP-IONS!" reads "Chomp-ions!". Kept as set: a Roman numeral (letters I, V, X, L only, 2 to 5 of them:
  // "POPE LEO XIV"), a word of single hyphenated letters ("E-A-G-L-E-S!"), a single letter. Small words (a, an, and,
  // at, by, for, in, of, on, or, the, to, with) are lower case unless first. A title with any lower-case letter is
  // left alone.
  var SMALL = ['a', 'an', 'and', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'with'];
  function displayTitle(main) {
    var t = String(main || '');
    if (!/[A-Z]/.test(t) || /[a-z]/.test(t)) return t;
    return t.split(' ').map(function (w, i) {
      var bare = w.toLowerCase().replace(/[!,.?]/g, '');
      if (bare.length <= 1) return w;
      if (/^[ivxl]{2,5}$/.test(bare)) return w;
      if (bare.indexOf('-') !== -1 && bare.split('-').every(function (p) { return p.length <= 1; })) return w;
      var lw = w.toLowerCase();
      if (i > 0 && SMALL.indexOf(bare) !== -1) return lw;
      var m = /^(['"‘“]*)(.*)$/.exec(lw);
      return m[1] + m[2].charAt(0).toUpperCase() + m[2].slice(1);
    }).join(' ');
  }

  // The colophon heading ("The book"): A/An + edition word + noun. Noun by binding and size: a hardcover whose long side
  // is 10 in or more is a "coffee-table book", a smaller one a "hardcover"; "softcover"; "spiral-bound book"; else
  // "book". Edition: collector's -> "collector’s edition", "limited edition" -> "limited-edition" (any "x edition" ->
  // "x-edition"). No edition: a large hardcover reads "hardcover coffee-table book".
  function bookNoun(binding, w, h) {
    var b = String(binding || '').toLowerCase(), long = Math.max(+w || 0, +h || 0);
    if (b.indexOf('hard') !== -1) return long >= 10 ? 'coffee-table book' : 'hardcover';
    if (b.indexOf('soft') !== -1) return 'softcover';
    if (b.indexOf('spiral') !== -1) return 'spiral-bound book';
    return 'book';
  }
  function editionWord(edition) {
    var e = String(edition || '').trim().toLowerCase();
    if (!e) return '';
    if (e.indexOf('collector') !== -1) return 'collector’s edition';
    return e.replace(/ edition$/, '-edition');
  }
  function bookHeading(binding, edition, w, h) {
    var noun = bookNoun(binding, w, h), ed = editionWord(edition);
    var phrase = ed ? ed + ' ' + noun : (noun === 'coffee-table book' ? 'hardcover ' + noun : noun);
    return (/^[aeiou]/i.test(phrase) ? 'An ' : 'A ') + phrase;
  }

  // The colophon's Size row, the GemPage's formula: a hardcover's case is 0.25 in over the trim each way; the depth is
  // product-depth, else left out (no 0.5 in default: it understated most books). Trailing ".0" dropped.
  function num(n) { var s = String(Math.round(n * 1000) / 1000); return s; }
  function sizeLine(binding, w, h, depth) {
    if (!(w > 0 && h > 0)) return '';
    var b = String(binding || '').toLowerCase(), over = b.indexOf('hard') !== -1 ? 0.25 : 0;
    var d = depth > 0 ? depth : 0;
    return [num(w + over), num(h + over)].concat(d ? [num(d)] : []).join(' × ') + ' in';
  }

  // The box of the pixels darker than `threshold` (luminance, 0-255) in RGBA data of an image w x h, as fractions;
  // a row or column counts once it has `min` such pixels (so a stray JPEG speck does not). null when there are none.
  function measure(data, w, h, threshold, min) {
    var cols = new Array(w), rows = new Array(h), x, y, i;
    for (x = 0; x < w; x++) cols[x] = 0;
    for (y = 0; y < h; y++) rows[y] = 0;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        i = (y * w + x) * 4;
        if (data[i + 3] < 128) continue;
        if (0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2] < threshold) { cols[x]++; rows[y]++; }
      }
    }
    min = min || 1;
    var x0 = -1, x1 = -1, y0 = -1, y1 = -1;
    for (x = 0; x < w; x++) if (cols[x] >= min) { if (x0 < 0) x0 = x; x1 = x; }
    for (y = 0; y < h; y++) if (rows[y] >= min) { if (y0 < 0) y0 = y; y1 = y; }
    if (x0 < 0 || y0 < 0) return null;
    return { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
  }

  // The render's paper white: the mean of the four corners' 4 x 4 patches, per channel (a lander render's ground is
  // not always 255; at 254 the multiplied image would sit one level darker than the page, a faint box). null when the
  // corners are not near white (not a white-ground render).
  function ground(data, w, h) {
    var sum = [0, 0, 0], n = 0, corners = [[0, 0], [w - 4, 0], [0, h - 4], [w - 4, h - 4]];
    corners.forEach(function (c) {
      for (var y = Math.max(0, c[1]); y < Math.min(h, c[1] + 4); y++) {
        for (var x = Math.max(0, c[0]); x < Math.min(w, c[0] + 4); x++) {
          var i = (y * w + x) * 4;
          sum[0] += data[i]; sum[1] += data[i + 1]; sum[2] += data[i + 2]; n++;
        }
      }
    });
    if (!n) return null;
    var g = sum.map(function (v) { return v / n; });
    return Math.min(g[0], g[1], g[2]) >= 240 ? g : null;
  }

  // Places the cover render by the BOOK, not by the file. book: the book's box in the image; ar: the image's
  // width / height; frame: the frame's width / height; target: where the book should sit, in fractions of the frame
  // (x of its width, y of its height). The book fills target as far as it can (width- or height-limited) and is centred
  // on it. ink (optional): the box of everything visible (the shadow included), which must stay inside outer (fractions
  // of the frame, may run past 0..1: the bleed); the scale shrinks until it does, the book still centred on target.
  // Returns the image's left, top and width as percentages of the frame (top of its height, the others of its width).
  function place(book, ar, frame, target, ink, outer) {
    var bw = book.x1 - book.x0, bh = (book.y1 - book.y0) / ar;            // image-width units
    var tw = target.x1 - target.x0, th = (target.y1 - target.y0) / frame;  // frame-width units
    var s = Math.min(tw / bw, th / bh);
    var cx = (target.x0 + target.x1) / 2, cy = (target.y0 + target.y1) / 2 / frame;  // frame-width units
    var bcx = (book.x0 + book.x1) / 2, bcy = (book.y0 + book.y1) / 2 / ar;         // image-width units
    if (ink && outer) {
      var lim = [
        [bcx - ink.x0, cx - outer.x0], [ink.x1 - bcx, outer.x1 - cx],
        [bcy - ink.y0 / ar, cy - outer.y0 / frame], [ink.y1 / ar - bcy, outer.y1 / frame - cy]
      ];
      lim.forEach(function (l) { if (l[0] > 0 && l[1] > 0) s = Math.min(s, l[1] / l[0]); });
    }
    var left = cx - bcx * s, top = cy - bcy * s;
    var r = function (v) { return Math.round(v * 10000) / 100; };
    return { left: r(left), top: r(top * frame), width: r(s) };
  }

  // The quantity offer (DealEasy's DE-4_Bundle, applied at the cart): pct off the line from `min` copies. Returns the
  // line before the discount, the saving (rounded to the cent) and the total, all cents.
  // DealEasy (DE-4_Bundle) takes the percent off each copy, dropping the fraction of a cent, so 5% off $39.95 is
  // $1.99 a copy and 4 copies come to $151.84 at checkout (checked 2026-10-14), not 5% of the line.
  function tier(priceCents, qty, pct, min) {
    var line = priceCents * qty, save = qty >= min ? Math.floor(priceCents * pct / 100 + 1e-9) * qty : 0;
    return { line: line, save: save, total: line - save };
  }

  function money(cents) {
    var n = Math.round(cents) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return {
    splitTitle: splitTitle, displayTitle: displayTitle, bookNoun: bookNoun, editionWord: editionWord,
    bookHeading: bookHeading, sizeLine: sizeLine, measure: measure, ground: ground, place: place, tier: tier, money: money
  };
});
